import React, { useState, useEffect, useRef } from 'react'
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';
import AktuellesTabs from '../components/AktuellesTabs';
import Header_2 from '../headers/Header_2';
import TitleTextButton from '../modules/TitleTextButton';
import ImageTitleTextButton from '../modules/ImageTitleTextButton';
import SEO from '../components/Seo';

export const Aktuelles = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [pageData, setPageData] = useState(null);
    const [modules, setModules] = useState(null);
    const [headerModules, setHeaderModules] = useState(null);

    const [metaData, setMetaData] = useState(null);

    const getPageData = async () => {
        setIsLoading(true)
        try {
            const response = await fetch("https://backend.bgzurlinden.ch/api/aktuelles-page?populate[Bannerbereich][on][header.header-2-text-bild][populate][Bild]=true&populate[Bannerbereich][on][header.header-2-text-bild][populate][Videominiatur]=true&populate[Metadaten]=*");



            // ?populate[Bannerbereich][on][header.header-1-titel-text][populate][Button]=true

            // &populate[Modul][on][modules.formulare-reglemente-dokumente][populate][Titel_Text]=*
            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][Bild]=true
            // &populate[Modul][on][modules.themenmodul-komplett][populate][Themen][populate][PDF]=true
            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][siedlungen_kategorien][populate]=*

            // &populate[Modul][on][modules.bestandesliegen-schaften][populate][siedlungens][populate][Bannerbereich][on][header.header-3-titel-text-bild][populate][Bild]=true


            // populate[Modul][on][modules.news][populate][Kurztitel_Titel_Text_Button][populate]=*
            // populate[Modul][on][modules.news][populate][aktuelles][populate][aktuelles_kategorie][populate]=*

            const data = await response.json();
            console.log(data?.data?.Modul);

            if (data.data) {
                setPageData(data.data);
                setMetaData(data?.data?.Metadaten);
                setModules(data?.data?.Modul);
                setHeaderModules(data?.data?.Bannerbereich);
            }
        }
        catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }

    }

    useEffect(() => {
        getPageData();
    }, [])

    return (
        <div className='page-content'>
            {metaData && <SEO seoData={metaData} />}

            {!isLoading && (
                headerModules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "header.header-2-text-bild" && (
                            <Header_2 module={module} isLoading={isLoading} title={module?.Titel} description={module?.Beschreibung} image={module?.Bild} sectionClass="banners-aktuelles-pages" activePage='Aktuelles' sendTitle={false} />
                        )}
                    </React.Fragment>
                ))
            )}

            {!isLoading ? (
                modules?.map((module, index) => (
                    <React.Fragment key={index}>
                        {module.__component === "modules.short-titel-titel-text-button" &&
                            <section className={`pt-pb-10 sec-orange-color ${module?.Padding_Top ? '' : 'pt-0'} ${module?.Padding_Bottom ? '' : 'pb-0'} ${module?.grauer_Hintergrundfarbe ? 'sec-bg-grey' : ''}`}>

                                <div className='container'>
                                    <TitleTextButton data={module} shortTitle={module?.Kurztitel} title={module?.Titel} text={module?.Text} buttons={module?.Button} component={module?.Komponente} pdf={module?.PDF} />
                                </div>
                            </section>
                        }
                        {module.__component === "modules.carousel-bild-re-text" &&
                            <ImageTitleTextButton module={module} shortTitle={module?.Kurztitel} images={module?.Bild} title={module?.Titel} description={module?.Beschreibung} buttons={module?.Button} sectionColor="orange" imagePosition={module?.Bildposition} equalCol={module?.Gleiche_Spalten} />
                        }

                    </React.Fragment>
                ))
            ) : (
                <>
                    <section className={`banner_sec inner_banner wohnen-banner position-relative`}>
                        <div className='container'>
                            <div className='row'>
                                <div className='col-md-5 col-lg-4 banner-content pt-pb-10'>
                                    <h1>{<Skeleton count={1} />}</h1>
                                    <p>{<Skeleton count={3} />}</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className={`pt-pb-10 sec-orange-color`}>
                        <div className='container'>
                            <div className='title-text-button-module'>
                                {/* {shortTitle && <div className='subtitle'>{shortTitle}</div>} */}
                                <div className='row'>
                                    <div className='col-lg-5 title-col'>
                                        {/* {title && <h2 className='text-black mb-lg-4 mb-2'>{title}</h2>} */}
                                        <h2>{<Skeleton count={1} />}</h2>
                                    </div>
                                    <div className='col-lg-7 content-col mt-3 mt-lg-0 fw_strong_500'>
                                        <p>{<Skeleton count={3} />}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </>
            )}
            <section className='sec-aktuelles sec-darkgrey-color pt-pb-10'>
                <div className="container">
                    <AktuellesTabs />
                </div>
            </section>
        </div>
    )
}